import Icon from 'components/Icon/Icon.component';
import ArrowRight from 'images/icons/chevron-right.svg?react';
import { Translate } from 'react-localize-redux';
import { gradients } from 'style-utils/colors';
import computeDynamicDomId from 'utils/functions/computeDynamicDomId';
import { TabContentProps } from '../SlideInMenu.type';
import {
  OpenBetsIndicator,
  QuickInternalLink,
  TabContentGrid,
} from '../style/CompactSlideInMenu.style';
import { MenuCardOnRails } from '../style/SlideInMenu.style';

const bettingRegex = /^\w*scommesse\b\w*$/i;

function CompactTabContent({
  navbarContent,
  activeTabIndex,
  domIdPrefix,
}: TabContentProps) {
  const isBetting = bettingRegex.test(
    navbarContent?.menuTab?.[activeTabIndex]?.label || '',
  );

  const cards = navbarContent?.menuTab?.[activeTabIndex]?.cards;

  //  We do not know where to fetch open bets yet.
  const counter = -1;

  return (
    <>
      {isBetting && (
        <TabContentGrid
          padding={'24px 0 0'}
          id={computeDynamicDomId(domIdPrefix, 'tab-panel')}
        >
          <QuickInternalLink
            style={{ background: gradients.highlightOrange }}
            to="/last-transactions"
            search={{ type: 3, state: 2 }}
          >
            <OpenBetsIndicator counter={counter} hidden />
            <span>
              <Translate id="lbl.navbar.betting.openBets" />
            </span>
            <Icon svgIconComponent={ArrowRight} fill="currentColor" />
          </QuickInternalLink>
        </TabContentGrid>
      )}
      {cards && (
        <TabContentGrid padding={'24px 0 52px'}>
          {cards.map((card, index) => (
            <MenuCardOnRails key={index} menuCard={card} />
          ))}
        </TabContentGrid>
      )}
    </>
  );
}

export default CompactTabContent;
